"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _mobxReact = require("mobx-react");
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _Button = require("../../../Button");
var _FormattedComponents = require("../../../FormattedComponents");
var _InfoModal = _interopRequireDefault(require("../../../InfoModal"));
var _MediaUploader = _interopRequireDefault(require("../../../MediaUploader"));
var _SidePanel = require("../../../SidePanel");
var _ModalsTextBox = _interopRequireDefault(require("../../../ModalsTextBox"));
var _constants = require("./constants");
var _styles = require("./styles");
var _messages = _interopRequireDefault(require("./messages"));
var _lodash = require("lodash");
var _dec, _class;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var CheckFeedbackModal = (_dec = (0, _mobxReact.inject)('store'), (0, _SidePanel.withSidePanel)(_class = _dec(_class = (0, _mobxReact.observer)(_class = /*#__PURE__*/function (_Component) {
  function CheckFeedbackModal() {
    var _this;
    _classCallCheck(this, CheckFeedbackModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, CheckFeedbackModal, [].concat(args));
    _defineProperty(_this, "state", {
      canNavigateAway: true,
      isDesktop: true
    });
    _defineProperty(_this, "dropzoneRef", null);
    _defineProperty(_this, "mediaUploaderRef", null);
    _defineProperty(_this, "resolveImageRemoval", null);
    _defineProperty(_this, "rejectImageRemoval", null);
    _defineProperty(_this, "resizeListener", null);
    _defineProperty(_this, "handleResize", function () {
      var isDesktop = window.innerWidth >= 768;
      if (isDesktop !== _this.state.isDesktop) {
        _this.setState({
          isDesktop: isDesktop
        });
      }
    });
    _defineProperty(_this, "handleMediaUploaderUploadStart", function () {
      var store = _this.props.store;
      var dialog = store.feedbackDialog;
      dialog.setIsUploading(true);
    });
    _defineProperty(_this, "handleMediaUploaderUploadEnd", function () {
      var store = _this.props.store;
      var dialog = store.feedbackDialog;
      dialog.setIsUploading(false);
    });
    _defineProperty(_this, "handleMediaUploaderBeforeRemove", function () {
      var store = _this.props.store;
      var dialog = store.feedbackDialog;
      return new Promise(function (resolve, reject) {
        _this.resolveImageRemoval = resolve;
        _this.rejectImageRemoval = reject;
        dialog.setIsRemoveImageDialogOpen(true);
      });
    });
    _defineProperty(_this, "handleMediaUploaderChange", function (mediaUrl) {
      var store = _this.props.store;
      var dialog = store.feedbackDialog;
      dialog.setMediaUrl(mediaUrl);
    });
    _defineProperty(_this, "handleMediaUploaderError", function (_ref) {
      var type = _ref.type,
        data = _ref.data;
      var _this$props = _this.props,
        intl = _this$props.intl,
        store = _this$props.store;
      var formatMessage = intl.formatMessage;
      var checklistStore = store.checklist,
        dialog = store.feedbackDialog;
      if (type === 'networkError') {
        dialog.setIsTryAgainErrorDialogOpen(true);
      } else {
        dialog.setMediaUploadErrorText(formatMessage(_messages["default"][type] || _messages["default"].fileNotSupported, data));
        checklistStore.openErrorModal();
      }
    });
    _defineProperty(_this, "handleTextareaChange", function (event) {
      var setFeedbackText = _this.props.store.feedbackDialog.setFeedbackText;
      var feedbackText = event.target.value;
      if (feedbackText.length <= _constants.maxFeedbackLength) {
        setFeedbackText(event.target.value);
      }
    });
    _defineProperty(_this, "handleFormSubmit", function (event) {
      var _this$props2 = _this.props,
        stepId = _this$props2.stepId,
        store = _this$props2.store;
      var checklistStore = store.checklist,
        dialog = store.feedbackDialog;
      var feedbackText = dialog.feedbackText,
        isUploading = dialog.isUploading,
        mediaUrl = dialog.mediaUrl;
      event.preventDefault();
      if (isUploading) {
        dialog.setIsSaveWithoutNewImageDialogOpen(true);
      } else {
        checklistStore.updateChecklist(stepId, {
          feedbackText: feedbackText,
          mediaUrl: mediaUrl
        });
        _this.props.popSidePanel();
      }
    });
    _defineProperty(_this, "handleSaveWithoutNewImageDialogClose", function () {
      var store = _this.props.store;
      var dialog = store.feedbackDialog;
      dialog.setIsSaveWithoutNewImageDialogOpen(false);
    });
    _defineProperty(_this, "handleSaveWithoutNewImageDialogConfirm", function () {
      var _this$props3 = _this.props,
        stepId = _this$props3.stepId,
        store = _this$props3.store;
      var checklistStore = store.checklist,
        dialog = store.feedbackDialog;
      var feedbackText = dialog.feedbackText;
      checklistStore.updateChecklist(stepId, {
        feedbackText: feedbackText
      });
      dialog.setIsSaveWithoutNewImageDialogOpen(false);
      dialog.setIsUploading(false);
      _this.props.popSidePanel();
    });
    _defineProperty(_this, "handleTryAgainErrorDialogClose", function () {
      var store = _this.props.store;
      var dialog = store.feedbackDialog;
      dialog.setIsTryAgainErrorDialogOpen(false);
    });
    _defineProperty(_this, "handleTryAgainErrorDialogConfirm", function () {
      var store = _this.props.store;
      var dialog = store.feedbackDialog;
      dialog.setIsTryAgainErrorDialogOpen(false);
      if (_this.mediaUploaderRef && _this.mediaUploaderRef.wrappedInstance) {
        _this.mediaUploaderRef.wrappedInstance.retry();
      }
    });
    _defineProperty(_this, "handleRemoveImageDialogConfirm", function () {
      var store = _this.props.store;
      var dialog = store.feedbackDialog;
      dialog.setIsRemoveImageDialogOpen(false);
      if (typeof _this.resolveImageRemoval === 'function') {
        _this.resolveImageRemoval();
        _this.resolveImageRemoval = null;
        _this.rejectImageRemoval = null;
      }
    });
    _defineProperty(_this, "handleRemoveImageDialogClose", function () {
      var store = _this.props.store;
      var dialog = store.feedbackDialog;
      dialog.setIsRemoveImageDialogOpen(false);
      if (typeof _this.rejectImageRemoval === 'function') {
        _this.rejectImageRemoval();
        _this.resolveImageRemoval = null;
        _this.rejectImageRemoval = null;
      }
    });
    _defineProperty(_this, "closeModal", function (panelOption) {
      var store = _this.props.store;
      var feedbackDialog = store.feedbackDialog;
      if (!feedbackDialog.canNavigateAway) {
        feedbackDialog.openDiscardDialog(function () {
          if (feedbackDialog.canNavigateAway) {
            _this.props.popSidePanel();
          }
        });
        return false;
      } else {
        if (panelOption === false) {
          _this.props.popSidePanel();
        }
        return true;
      }
    });
    _defineProperty(_this, "openMediaUploaderDialog", function () {
      var store = _this.props.store;
      var checklistStore = store.checklist;
      if (_this.dropzoneRef) {
        _this.dropzoneRef.open();
      }
      checklistStore.closeErrorModal();
    });
    _defineProperty(_this, "setDropzoneRef", function (ref) {
      _this.dropzoneRef = ref;
    });
    _defineProperty(_this, "setMediaUploaderRef", function (ref) {
      _this.mediaUploaderRef = ref;
    });
    return _this;
  }
  _inherits(CheckFeedbackModal, _Component);
  return _createClass(CheckFeedbackModal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props4 = this.props,
        stepId = _this$props4.stepId,
        store = _this$props4.store;
      var dialog = store.feedbackDialog;
      dialog.init(stepId);
      this.resizeListener = window.addEventListener('resize', (0, _lodash.debounce)(this.handleResize, 100));
      this.handleResize();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.resizeListener);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this2 = this;
      var store = this.props.store;
      var dialog = store.feedbackDialog;
      var canNavigateAway = dialog.canNavigateAway;
      if (canNavigateAway != this.state.canNavigateAway) {
        this.setState({
          canNavigateAway: canNavigateAway
        });
        if (!canNavigateAway) {
          this.props.setLastPanelOptions({
            onClose: function onClose() {
              return _this2.closeModal(true);
            }
          });
        } else {
          this.props.setLastPanelOptions({
            onClose: undefined
          });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var isDesktop = this.state.isDesktop;
      var _this$props5 = this.props,
        intl = _this$props5.intl,
        store = _this$props5.store;
      var formatMessage = intl.formatMessage;
      var checklistStore = store.checklist,
        dialog = store.feedbackDialog;
      var _dialog$feedbackText = dialog.feedbackText,
        feedbackText = _dialog$feedbackText === void 0 ? '' : _dialog$feedbackText,
        isDiscardDialogOpen = dialog.isDiscardDialogOpen,
        isRemoveImageDialogOpen = dialog.isRemoveImageDialogOpen,
        isSaveWithoutNewImageDialogOpen = dialog.isSaveWithoutNewImageDialogOpen,
        isTryAgainErrorDialogOpen = dialog.isTryAgainErrorDialogOpen,
        hasChanges = dialog.hasChanges,
        mediaUploadErrorText = dialog.mediaUploadErrorText,
        mediaUrl = dialog.mediaUrl;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_InfoModal["default"], {
        isDesktop: isDesktop,
        isOpen: isDiscardDialogOpen,
        leftButtonText: formatMessage(_messages["default"].cancel),
        onClose: function onClose() {
          return dialog.resolveCanDiscard(false);
        },
        onLeftButtonClick: function onLeftButtonClick() {
          return dialog.resolveCanDiscard(false);
        },
        onRightButtonClick: function onRightButtonClick() {
          return dialog.resolveCanDiscard(true);
        },
        rightButtonText: formatMessage(_messages["default"].discard),
        subtitle: formatMessage(_messages["default"].unsavedChangesSubtitle),
        title: formatMessage(_messages["default"].unsavedChangesTitle)
      }), /*#__PURE__*/_react["default"].createElement(_InfoModal["default"], {
        isDesktop: isDesktop,
        isOpen: isSaveWithoutNewImageDialogOpen,
        leftButtonText: formatMessage(_messages["default"].saveWithoutNewFile),
        onClose: this.handleSaveWithoutNewImageDialogClose,
        onLeftButtonClick: this.handleSaveWithoutNewImageDialogConfirm,
        onRightButtonClick: this.handleSaveWithoutNewImageDialogClose,
        rightButtonText: formatMessage(_messages["default"].cancel),
        subtitle: formatMessage(_messages["default"].fileStillUploadingSubtitle),
        title: formatMessage(_messages["default"].fileStillUploadingTitle)
      }), /*#__PURE__*/_react["default"].createElement(_InfoModal["default"], {
        isDesktop: isDesktop,
        isOpen: checklistStore.showErrorModal,
        leftButtonText: formatMessage(_messages["default"].cancel),
        onClose: checklistStore.closeErrorModal,
        onLeftButtonClick: checklistStore.closeErrorModal,
        onRightButtonClick: this.openMediaUploaderDialog,
        rightButtonText: formatMessage(_messages["default"].uploadNew),
        subtitle: mediaUploadErrorText,
        title: formatMessage(_messages["default"].couldNotUploadFileTitle)
      }), /*#__PURE__*/_react["default"].createElement(_InfoModal["default"], {
        isDesktop: isDesktop,
        isOpen: isTryAgainErrorDialogOpen,
        leftButtonText: formatMessage(_messages["default"].cancel),
        onClose: this.handleTryAgainErrorDialogClose,
        onLeftButtonClick: this.handleTryAgainErrorDialogClose,
        onRightButtonClick: this.handleTryAgainErrorDialogConfirm,
        rightButtonText: formatMessage(_messages["default"].tryAgain),
        subtitle: formatMessage(_messages["default"].couldNotUploadFileSubtitle),
        title: formatMessage(_messages["default"].couldNotUploadFileTitle)
      }), /*#__PURE__*/_react["default"].createElement(_InfoModal["default"], {
        isDesktop: isDesktop,
        isOpen: isRemoveImageDialogOpen,
        leftButtonText: formatMessage(_messages["default"].cancel),
        onClose: this.handleRemoveImageDialogClose,
        onLeftButtonClick: this.handleRemoveImageDialogClose,
        onRightButtonClick: this.handleRemoveImageDialogConfirm,
        rightButtonText: formatMessage(_messages["default"]["delete"]),
        subtitle: formatMessage(_messages["default"].removeFileSubtitle),
        title: formatMessage(_messages["default"].removeFileTitle)
      }), /*#__PURE__*/_react["default"].createElement(_styles.Container, null, /*#__PURE__*/_react["default"].createElement(_styles.ContentWrapper, {
        isDesktop: isDesktop
      }, /*#__PURE__*/_react["default"].createElement(_styles.Description, null, /*#__PURE__*/_react["default"].createElement(_FormattedComponents.FormattedMessage, _messages["default"].addFeedbackSubtitle)), /*#__PURE__*/_react["default"].createElement(_styles.Label, null, formatMessage(_messages["default"].details)), /*#__PURE__*/_react["default"].createElement(_ModalsTextBox["default"], {
        isDesktop: isDesktop,
        handleTextareaChange: this.handleTextareaChange,
        placeholder: formatMessage(_messages["default"].typeYourComment),
        value: feedbackText,
        maxFeedbackLength: _constants.maxFeedbackLength,
        dataCy: 'feedback-text-check'
      }), /*#__PURE__*/_react["default"].createElement(_styles.MediaUploaderWrapper, {
        isDesktop: isDesktop
      }, /*#__PURE__*/_react["default"].createElement(_MediaUploader["default"], {
        dropzoneRef: this.setDropzoneRef,
        isDesktop: isDesktop,
        onUploadStart: this.handleMediaUploaderUploadStart,
        onUploadEnd: this.handleMediaUploaderUploadEnd,
        onBeforeRemove: this.handleMediaUploaderBeforeRemove,
        onChange: this.handleMediaUploaderChange,
        onError: this.handleMediaUploaderError,
        ref: this.setMediaUploaderRef,
        value: mediaUrl
      }))), /*#__PURE__*/_react["default"].createElement(_styles.ButtonsContainer, null, /*#__PURE__*/_react["default"].createElement(_Button.Button, {
        "aria-label": "save",
        "data-cy": 'save-feedback-check',
        onClick: this.handleFormSubmit,
        disabled: !hasChanges
      }, formatMessage(_messages["default"].saveDetails)), /*#__PURE__*/_react["default"].createElement(_Button.Button, {
        "aria-label": "cancel",
        design: "outline",
        onClick: function onClick() {
          return _this3.closeModal(false);
        }
      }, formatMessage(_messages["default"].cancel)))));
    }
  }]);
}(_react.Component)) || _class) || _class) || _class);
var _default = exports["default"] = (0, _reactIntl.injectIntl)(CheckFeedbackModal);
//# sourceMappingURL=index.js.map